import clsx from 'clsx';
import { useState } from 'react';

import { ProgressiveImage } from '@gitbook/spine-react';

import previewDark from './assets/stacked-showcase-dark.webp';
import previewLight from './assets/stacked-showcase-light.webp';

export function DocsPreview() {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <div className="relative -right-14 z-50 flex h-full w-full justify-end">
            <ProgressiveImage
                rounded={false}
                resize={false}
                src={{ light: previewLight, dark: previewDark }}
                alt="Multiple docs example"
                loading="eager"
                fetchPriority="high"
                className={clsx(
                    'absolute block min-h-dvh w-[50vw]',
                    'transition-[filter,opacity] duration-500 ease-out',
                    isLoaded ? 'blur-0 opacity-100' : 'opacity-0 blur-[16px]'
                )}
                onLoad={() => setIsLoaded(true)}
            />

            <link rel="preload" as="image" href={previewDark} />
            <link rel="preload" as="image" href={previewLight} />
        </div>
    );
}
